import React, { useMemo } from 'react'
import { Datagrid } from 'react-admin'
import { useCanAccess } from '../../hooks'
import { createOrCloneElement } from '../../utils/component'
import { BulkActionButtonsWithPermission } from '../bulk-action-buttons/BulkActionButtonsWithPermission'
import { ImageGrid } from '../image-grid'
import { ListViewBaseProps } from './type'

const ComponentListGrid = {
  Datagrid: Datagrid,
  ImageGrid: ImageGrid,
}

const ListViewBase: React.FC<ListViewBaseProps> = ({ children }) => {
  const { permission } = useCanAccess()
  // define the permission for decicing display the checkbox on row
  const hasBulkActions = useMemo(() => permission && permission.deletable, [permission])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const bulkActionButtons = useMemo(
    () =>
      hasBulkActions ? (
        <>
          <BulkActionButtonsWithPermission />
          {children.props.bulkActionButtons}
        </>
      ) : (
        children.props.bulkActionButtons
      ),
    [children.props.bulkActionButtons, hasBulkActions],
  )
  const { displayName } = children.type
  const PrototypeComponent = displayName ? ComponentListGrid[displayName] : null
  return PrototypeComponent
    ? createOrCloneElement(
        PrototypeComponent,
        {
          ...children.props,
          bulkActionButtons: children.props.bulkActionButtons == false ? false : bulkActionButtons,
        },
        children.props.children,
      )
    : children
}

export default ListViewBase
